export default {
  addItem: "Add Item",
  amountPaid: "Amount Paid",
  amountDue: "Amount Due",
  summary: "Summary",
  customFields: "Custom Fields",
  noCustomFields: "No custom fields",
  deleteImage: "Delete Image",
  deleteImageConfirmation: "Are you sure you want to delete the image?",
  processingFee: "Processing Fee",
  transactions: "Transactions",
  allowPartialPaymentForInvoices: "Allow partial payment for invoices",
  allowPartialPaymentForInvoicesInfo:
    "If toggled, all new invoices will have the option to pay a partial amount.",
  hideInvoiceDetails: "Hide invoice details",
  showInvoiceDetails: "Show invoice details",
  activitySection: "Activity",
  passOnCreditCardFeeForInvoices: "Pass on credit card as a surcharge",
  passOnCreditCardFeeForInvoicesInfo:
    "If toggled, all new invoices will have a credit card fee added to the total amount. Please consider carefully your local laws and regulations before enabling this feature. invup.me is not responsible for any legal issues that may arise from using this feature.",
  allowPartialPayment: "Allow partial payment",
  allowPartialPaymentDescription:
    "Toggle this option to allow payment of this invoice in installments.",
  invoiceSettings: "Settings",
  lastUpdated: "Last updated",
  timeAgoJustNow: "just now",
  timeAgoSeconds: "{{count}}s ago",
  timeAgoMinutes: "{{count}}m ago",
  timeAgoHours: "{{count}}h ago",
  timeAgoDays: "{{count}}d ago",
  timeAgoMonths: "{{count}}mo ago",
  timeAgoYears: "{{count}}y ago",
  overrideDeltaComputed: "Computed",
  overrideDeltaOverride: "Override",
  active: "Active",
  paused: "Paused",
  stopped: "Stopped",
  pause: "Pause",
  resume: "Resume",
  generatedInvoices: "Generated Invoices",
  noGeneratedInvoices: "No invoices have been generated yet.",
  settings: "Settings",
  settingsUpdatedSuccessfully: "Settings updated successfully",
  invoiceNumbering: "Invoice numbering",
  invoiceNumberStart: "Starting number",
  invoiceNumberStartInfo:
    "The next invoice will use this number. Must be greater than the highest existing invoice number.",
  invoiceNumberPrefix: "Number prefix",
  invoiceNumberPrefixInfo:
    "Optional text prepended to every invoice number (e.g., INV-). Leave blank for no prefix.",
  receiptNumbering: "Receipt numbering",
  receiptNumberStart: "Starting number",
  receiptNumberStartInfo:
    "The next receipt will use this number. Must be greater than the highest existing receipt number.",
  receiptNumberPrefix: "Number prefix",
  receiptNumberPrefixInfo:
    "Optional text prepended to every receipt number (e.g., RCP-). Leave blank for no prefix.",
  info: "Info",
  basics: "Basics",
  schedule: "Schedule",
  payment: "Payment",
  source: "Source",
  code: "Code",
  client: "Client",
  clients: "Clients",
  invoices: "Invoices",
  passOnProcessingFee: "Pass on processing fee",
  passOnCreditCardFee: "Pass on credit card fee",
  passOnCreditCardFeeInfo:
    "If toggled, the base credit card fees for your payment processor will be added to the total amount. Please consider carefully your local laws and regulations before enabling this feature. invup.me is not responsible for any legal issues that may arise from using this feature.",
  invoiceDeleted: "Invoice deleted successfully",
  confirmDeleteMessage:
    "Are you sure you want to delete the selected invoices? This action cannot be undone.",
  confirmDeleteTitle: "Delete Invoices",
  emailTemplates: "Email templates",
  firstInvoiceReminder: "First invoice reminder",
  secondInvoiceReminder: "Second invoice reminder",
  thirdInvoiceReminder: "Third invoice reminder",
  reminderTemplatesUpdated: "Reminder templates updated",
  sendFirstReminder: "Send first reminder",
  sendFirstReminderInfo:
    "Toggle this option if you want to send the first invoice reminder. The first invoice reminder is sent 7 days before the invoice is due.",
  sendSecondReminder: "Send second reminder",
  sendSecondReminderInfo:
    "Toggle this option if you want to send the second invoice reminder. The second invoice reminder is sent 3 days before the invoice is due.",
  sendThirdReminder: "Send third reminder",
  sendThirdReminderInfo:
    "Toggle this option if you want to send the third invoice reminder. The third invoice reminder is sent 1 day before the invoice is due.",
  reminderInfo:
    "Recipients can receive up to three invoice reminders after an invoice is sent. However, reminders are never sent during the first 48 hours after an invoice goes out, so any reminder scheduled to occur within that window is skipped. You can customize the content for each reminder below.",
  latePaymentFee: "Late payment fee",
  netDays: "Net days",
  netDaysInfo:
    "Number of days from a generated invoice's issue date until it is due. Use 30 for Net 30, 0 for due-on-issue.",
  latePaymentFeeDescription:
    "Use this field to select a fee that will be added to any invoice that is past due. This fee will be added to the invoice balance.",
  otherFees: "Other Fees",
  subtotal: "Subtotal",
  tax: "Tax",
  surcharge: "Surcharge",
  fees: "Fees",
  total: "Total",
  overrides: "Invoice Overrides",
  overridesDescription:
    "Manually set any of the summary totals below. Leave a field blank to fall back to the calculated value.",
  subtotalOverride: "Subtotal override",
  discountOverride: "Discount override",
  taxOverride: "Tax override",
  feesOverride: "Fees override",
  overrideHelper: "Leave blank to use the calculated value.",
  computedValue: "Calculated: {{value}}",
  withPdf: "With PDF",
  withPdfInfo:
    "If toggled, the invoice email will be sent with a PDF attachment.",
  copySelf: "Copy Self",
  copySelfInfo:
    "If toggled, you will be copied in the sent email. This is useful for keeping a record of the email.",
  sendInvoiceSuccess: "Invoice email has been queued for sending.",
  paid: "Paid",
  logo: "Logo",
  uploadInvoiceLogo: "Upload Invoice Logo",
  scheduleSend: "Schedule Send",
  scheduleSendInfo: "If toggled, you can schedule the email to be sent later.",
  scheduleSendDate: "Schedule Send Date and Time",
  scheduleSendDateInfo:
    "Select the date and time you want the email to be sent.",
  sendInvoice: "Send Invoice",
  sendInvoiceConfirmation:
    "How would you like this invoice to be sent? You can choose to send it now or schedule it to be sent later. You can also choose to include a PDF attachment. The client's contacts will automatically be CC'd on the email. Please note that once sent, the email cannot be recalled.",
  scheduleSendDateError:
    "The scheduled send date must be at least 1 hour in the future.",
  sentAt: "Last sent at: {{date}}",
  scheduledToSendAt: "Scheduled to send at: {{date}}",
  scheduleSendConfirmation:
    'This invoice has been scheduled to be sent on {{date}}. To change the scheduled date, or to send the invoice immediately, please click the "Clear Schedule" button.',
  clearScheduleSuccess: "Scheduled send cleared successfully.",
  clearScheduleFailed: "Failed to clear scheduled send.",
  clearSchedule: "Clear Schedule",
  resend: "Resend",
  resendConfirmation:
    "Are you sure you want to resend this invoice? The email will be sent to the client with a PDF attachment.",
  recordPayment: "Record Payment",
  addDiscount: "Add Discount",
  discounts: "Discounts",
  downloadInvoice: "Download Invoice",
  downloadConfirmationMessage:
    "Are you sure you want to download this invoice?",
  discount: "Discount",
  recurring: "Recurring",
  recurringInvoices: "Recurring Invoices",
  newRecurringInvoice: "New Recurring Invoice",
  currency: "Currency",
  frequency: "Frequency",
  weekly: "Weekly",
  biweekly: "Biweekly",
  monthly: "Monthly",
  yearly: "Yearly",
  dayOfWeek: "Day of Week",
  dayOfMonth: "Day of Month",
  dateOfYearMonth: "Month of Year",
  dateOfYearDate: "Date of Month",
  stopRecurringOn: "Stop Recurring On",
  maxOccurrences: "Max Number of Occurrences",
  paymentInstructions: "Payment Instructions",
  termsLabel: "Terms",
  termsPlaceholder: "Add terms shown on the invoice PDF and email",
  termsSaved: "Invoice terms saved.",
  invoiceItem: "Invoice Item",
  itemName: "Name",
  itemDescription: "Description",
  itemQuantity: "Quantity",
  itemPrice: "Price",
  discountItem: "Discount Item",
  deleteDiscount: "Delete Discount",
  discountType: "Discount Type",
  discountValue: "Discount Value",
  surcharges: "Surcharges",
  date: "Date",
  never: "Never",
  afterCount: "After Count",
  stopOnDate: "Stop On Date",
  stopRecurring: "Stop Creating New Invoices",
  endsAfter: "Ends After",
  stopsAfterDays: "{{days}} days",
  name: "Name",
  recurringInvoiceDeleted: "Recurring invoice(s) successfully delete.",
  recurringInvoiceDeleteConfirmationTitle: "Delete Recurring Invoice",
  recurringInvoiceDeleteConfirmationMessage:
    "Are you sure you want to delete the selected recurring invoices? This action cannot be undone.",
  noTransactions: "No transactions",
  selectTaxes: "Select taxes",
  invoiceTaxes: "Invoice Taxes",
  selectInvoiceTaxes: "Select Invoice Taxes",
  sourceSelectionDescription: "How would you like to create this invoice?",
  fromScratch: "From Scratch",
  fromScratchDescription: "Create an invoice with custom line items",
  fromTimeEntries: "From Time Entries",
  fromTimeEntriesDescription: "Generate line items from tracked time entries",
  timeEntriesWizardPlaceholder: "Time entries invoice wizard coming soon...",
  selectClient: "Select Client",
  selectClientInfo:
    "Choose a client to invoice. Only clients with projects that have time entries are shown.",
  noClientsFound: "No clients found",
  filterTimeEntries: "Filter Time Entries",
  dateFrom: "From",
  dateTo: "To",
  projects: "Projects",
  services: "Services",
  members: "Members",
  billableOnly: "Billable entries only",
  excludeInvoiced: "Exclude already invoiced entries",
  noMatchingEntries: "No time entries match the current filters",
  entries: "Entries",
  totalHours: "Total Hours",
  estimatedTotal: "Estimated Total",
  byProject: "By Project",
  previewInTable: "Preview in Time Entries Table",
  selectProjects: "Select projects...",
  selectServices: "Select services...",
  selectMembers: "Select members...",
  selectGrouping: "How should line items be grouped?",
  groupingSingle: "Single Line Item",
  groupingSingleDescription: "All entries become one line item",
  groupingByProject: "By Project",
  groupingByProjectDescription: "One line item per project",
  groupingByService: "By Service",
  groupingByServiceDescription: "One line item per service",
  groupingByMember: "By Member",
  groupingByMemberDescription: "One line item per team member",
  groupingByEntry: "By Time Entry",
  groupingByEntryDescription: "One line item per time entry",
  useTimeEntryDescription: "Include time-entry descriptions",
  lineItem: "line item",
  lineItems: "line items",
  createInvoice: "Create Invoice",
  createError: "Failed to create invoice. Please try again.",
  recurringSource: "Invoice Source",
  sourceManual: "Manual (Static Line Items)",
  sourceTimeEntries: "From Time Entries",
  timeEntryFilterConfig: "Time Entry Filter Configuration",
  wizardStepBasics: "Basics",
  wizardStepSchedule: "Schedule",
  wizardStepSourceItems: "Source & Items",
  wizardStepFeesTaxes: "Fees & Taxes",
  canvas: {
    invoice: "Invoice",
    dateOfIssue: "Date of issue",
    billTo: "Bill to",
    terms: "Terms",
    addRowTrigger: "+ Add",
    addLineItem: "Add line item",
    addTax: "+ Tax",
    addFee: "+ Fee",
    addDiscount: "Add discount",
    newDiscountName: "Discount",
    deleteLineItemTitle: "Delete line item",
    deleteLineItemMessage:
      "Are you sure you want to delete this line item? This action cannot be undone.",
    deleteDiscountTitle: "Delete discount",
    deleteDiscountMessage:
      "Are you sure you want to delete this discount? This action cannot be undone.",
    addTerms: "+ Add terms",
    addPaymentInstructions: "+ Add payment instructions",
    headerDescription: "Description",
    headerQty: "Qty",
    headerUnitPrice: "Unit price",
    headerAmount: "Amount",
    editClient: "Edit client",
    changeClient: "Change client",
    editClientTitle: "Edit client",
    changeClientTitle: "Change client",
    changeClientSearchPlaceholder: "Search clients",
    changeClientEmpty: "No clients found",
    changeClientConfirmTitle: "Change client?",
    changeClientConfirmMessage:
      "The bill-to address on this invoice will update accordingly.",
    changeClientSentMessage:
      "This invoice has already been sent. Changing the client will update the bill-to address on any future PDF re-download. The customer's emailed copy is unchanged.",
    manageTaxes: "Taxes",
    manageFees: "Fees",
    manageTaxModalTitle: "Manage taxes",
    manageFeeModalTitle: "Manage fees",
    manageLineItemTaxModalTitle: "Manage line item taxes",
    manageTaxSearchPlaceholder: "Search taxes",
    manageFeeSearchPlaceholder: "Search fees",
    noTaxesConfigured:
      "No taxes are configured. Configure taxes in Settings before adding one to an invoice.",
    noFeesConfigured:
      "No fees are configured. Configure fees in Settings before adding one to an invoice.",
  },
};
